import { colors } from '../../style-guide'

export const badgeTheme = {
   light: {
      GRAY: {
         bgColor: 'bg-gray-200',
         borderColor: 'border-gray-600',
         withBorderTextColor: 'text-gray-700',
         withOutBorderTextColor: 'text-gray-800',
         withOutBorderIconColor: colors['gray-500'],
         withBorderIconColor: colors['gray-600'],
         withOutBorderDotColor: 'bg-gray-500',
         withBorderDotColor: 'bg-gray-600'
      },
      PRIMARY: {
         bgColor: 'bg-primary-100',
         borderColor: 'border-primary-600',
         withBorderTextColor: 'text-primary-700',
         withOutBorderTextColor: 'text-primary-800',
         withOutBorderIconColor: colors['primary-500'],
         withBorderIconColor: colors['primary-600'],
         withOutBorderDotColor: 'bg-primary-500',
         withBorderDotColor: 'bg-primary-600'
      },
      ERROR: {
         bgColor: 'bg-error-100',
         borderColor: 'border-error-600',
         withBorderTextColor: 'text-error-700',
         withOutBorderTextColor: 'text-error-800',
         withOutBorderIconColor: colors['error-500'],
         withBorderIconColor: colors['error-600'],
         withOutBorderDotColor: 'bg-error-500',
         withBorderDotColor: 'bg-error-600'
      },
      SUCCESS: {
         bgColor: 'bg-success-100',
         borderColor: 'border-success-600',
         withBorderTextColor: 'text-success-700',
         withOutBorderTextColor: 'text-success-800',
         withOutBorderIconColor: colors['success-500'],
         withBorderIconColor: colors['success-600'],
         withOutBorderDotColor: 'bg-success-500',
         withBorderDotColor: 'bg-success-600'
      },
      WARNING: {
         bgColor: 'bg-warning-100',
         borderColor: 'border-warning-600',
         withBorderTextColor: 'text-warning-700',
         withOutBorderTextColor: 'text-warning-800',
         withOutBorderIconColor: colors['warning-500'],
         withBorderIconColor: colors['warning-600'],
         withOutBorderDotColor: 'bg-warning-500',
         withBorderDotColor: 'bg-warning-600'
      },
      PURPLE: {
         bgColor: 'bg-purple-100',
         borderColor: 'border-purple-600',
         withBorderTextColor: 'text-purple-700',
         withOutBorderTextColor: 'text-purple-800',
         withOutBorderIconColor: colors['purple-500'],
         withBorderIconColor: colors['purple-500'],
         withOutBorderDotColor: 'bg-purple-500',
         withBorderDotColor: 'bg-purple-600'
      },
      BLUE: {
         bgColor: 'bg-blue-100',
         borderColor: 'border-blue-600',
         withBorderTextColor: 'text-blue-700',
         withOutBorderTextColor: 'text-blue-800',
         withOutBorderIconColor: colors['blue-500'],
         withBorderIconColor: colors['blue-500'],
         withOutBorderDotColor: 'bg-blue-500',
         withBorderDotColor: 'bg-blue-600'
      },
      BLUE_DARK: {
         bgColor: 'bg-blue-dark-100',
         borderColor: 'border-blue-dark-600',
         withBorderTextColor: 'text-blue-dark-700',
         withOutBorderTextColor: 'text-blue-dark-800',
         withOutBorderIconColor: colors['blue-dark-500'],
         withBorderIconColor: colors['blue-dark-500'],
         withOutBorderDotColor: 'bg-blue-dark-500',
         withBorderDotColor: 'bg-blue-dark-600'
      },
      BLUE_LIGHT: {
         bgColor: 'bg-blue-light-100',
         borderColor: 'border-blue-light-600',
         withBorderTextColor: 'text-blue-light-700',
         withOutBorderTextColor: 'text-blue-light-800',
         withOutBorderIconColor: colors['blue-light-500'],
         withBorderIconColor: colors['blue-light-500'],
         withOutBorderDotColor: 'bg-blue-light-500',
         withBorderDotColor: 'bg-blue-light-600'
      },
      CYAN: {
         bgColor: 'bg-cyan-100',
         borderColor: 'border-cyan-600',
         withBorderTextColor: 'text-cyan-700',
         withOutBorderTextColor: 'text-cyan-800',
         withOutBorderIconColor: colors['cyan-500'],
         withBorderIconColor: colors['cyan-500'],
         withOutBorderDotColor: 'bg-cyan-500',
         withBorderDotColor: 'bg-cyan-600'
      },
      FUCHSIA: {
         bgColor: 'bg-fuchsia-100',
         borderColor: 'border-fuchsia-600',
         withBorderTextColor: 'text-fuchsia-700',
         withOutBorderTextColor: 'text-fuchsia-800',
         withOutBorderIconColor: colors['fuchsia-500'],
         withBorderIconColor: colors['fuchsia-500'],
         withOutBorderDotColor: 'bg-fuchsia-500',
         withBorderDotColor: 'bg-fuchsia-600'
      },
      GREEN: {
         bgColor: 'bg-green-100',
         borderColor: 'border-green-600',
         withBorderTextColor: 'text-green-700',
         withOutBorderTextColor: 'text-green-800',
         withOutBorderIconColor: colors['green-500'],
         withBorderIconColor: colors['green-500'],
         withOutBorderDotColor: 'bg-green-500',
         withBorderDotColor: 'bg-green-600'
      },
      GREEN_LIGHT: {
         bgColor: 'bg-green-light-100',
         borderColor: 'border-green-light-600',
         withBorderTextColor: 'text-green-light-700',
         withOutBorderTextColor: 'text-green-light-800',
         withOutBorderIconColor: colors['green-light-500'],
         withBorderIconColor: colors['green-light-500'],
         withOutBorderDotColor: 'bg-green-light-500',
         withBorderDotColor: 'bg-green-light-600'
      },
      INDIGO: {
         bgColor: 'bg-indigo-100',
         borderColor: 'border-indigo-600',
         withBorderTextColor: 'text-indigo-700',
         withOutBorderTextColor: 'text-indigo-800',
         withOutBorderIconColor: colors['indigo-500'],
         withBorderIconColor: colors['indigo-500'],
         withOutBorderDotColor: 'bg-indigo-500',
         withBorderDotColor: 'bg-indigo-600'
      },
      MOSS: {
         bgColor: 'bg-moss-100',
         borderColor: 'border-moss-600',
         withBorderTextColor: 'text-moss-700',
         withOutBorderTextColor: 'text-moss-800',
         withOutBorderIconColor: colors['moss-500'],
         withBorderIconColor: colors['moss-500'],
         withOutBorderDotColor: 'bg-moss-500',
         withBorderDotColor: 'bg-moss-600'
      },
      ORANGE: {
         bgColor: 'bg-orange-100',
         borderColor: 'border-orange-600',
         withBorderTextColor: 'text-orange-700',
         withOutBorderTextColor: 'text-orange-800',
         withOutBorderIconColor: colors['orange-500'],
         withBorderIconColor: colors['orange-500'],
         withOutBorderDotColor: 'bg-orange-500',
         withBorderDotColor: 'bg-orange-600'
      },
      ORANGE_DARK: {
         bgColor: 'bg-orange-dark-100',
         borderColor: 'border-orange-dark-600',
         withBorderTextColor: 'text-orange-dark-700',
         withOutBorderTextColor: 'text-orange-dark-800',
         withOutBorderIconColor: colors['orange-dark-500'],
         withBorderIconColor: colors['orange-dark-500'],
         withOutBorderDotColor: 'bg-orange-dark-500',
         withBorderDotColor: 'bg-orange-dark-600'
      },
      PINK: {
         bgColor: 'bg-pink-100',
         borderColor: 'border-pink-600',
         withBorderTextColor: 'text-pink-700',
         withOutBorderTextColor: 'text-pink-800',
         withOutBorderIconColor: colors['pink-500'],
         withBorderIconColor: colors['pink-500'],
         withOutBorderDotColor: 'bg-pink-500',
         withBorderDotColor: 'bg-pink-600'
      },
      ROSE: {
         bgColor: 'bg-rose-100',
         borderColor: 'border-rose-600',
         withBorderTextColor: 'text-rose-700',
         withOutBorderTextColor: 'text-rose-800',
         withOutBorderIconColor: colors['rose-500'],
         withBorderIconColor: colors['rose-500'],
         withOutBorderDotColor: 'bg-rose-500',
         withBorderDotColor: 'bg-rose-600'
      },
      TEAL: {
         bgColor: 'bg-teal-100',
         borderColor: 'border-teal-600',
         withBorderTextColor: 'text-teal-700',
         withOutBorderTextColor: 'text-teal-800',
         withOutBorderIconColor: colors['teal-500'],
         withBorderIconColor: colors['teal-500'],
         withOutBorderDotColor: 'bg-teal-500',
         withBorderDotColor: 'bg-teal-600'
      },
      VIOLET: {
         bgColor: 'bg-violet-100',
         borderColor: 'border-violet-600',
         withBorderTextColor: 'text-violet-700',
         withOutBorderTextColor: 'text-violet-800',
         withOutBorderIconColor: colors['violet-500'],
         withBorderIconColor: colors['violet-500'],
         withOutBorderDotColor: 'bg-violet-500',
         withBorderDotColor: 'bg-violet-600'
      },
      YELLOW: {
         bgColor: 'bg-yellow-100',
         borderColor: 'border-yellow-600',
         withBorderTextColor: 'text-yellow-700',
         withOutBorderTextColor: 'text-yellow-800',
         withOutBorderIconColor: colors['yellow-500'],
         withBorderIconColor: colors['yellow-500'],
         withOutBorderDotColor: 'bg-yellow-500',
         withBorderDotColor: 'bg-yellow-600'
      }
   },
   dark: {}
}
